"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalIntlWrapper = exports.createInternalIntl = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var translations_1 = require("./translations");
var util_1 = require("@gooddata/util");
var INTL_CACHE_SIZE = 20;
var INTL_CACHE_KEY = "messages";
var intlCache = new util_1.LRUCache({ maxSize: INTL_CACHE_SIZE });
function createInternalIntl(locale) {
    if (locale === void 0) { locale = sdk_ui_1.DefaultLocale; }
    /**
     * Because of issues described in the ticket FET-855, we decided to use this workaround.
     * After the issues that are described in the ticket are solved or at least reduced,
     * this workaround can be removed.
     */
    var settings = window.gdSettings;
    if (!intlCache.get(INTL_CACHE_KEY)) {
        intlCache.set(INTL_CACHE_KEY, sdk_ui_1.pickCorrectWording(translations_1.translations[locale], settings));
    }
    return react_intl_1.createIntl({ locale: locale, messages: intlCache.get(INTL_CACHE_KEY) });
}
exports.createInternalIntl = createInternalIntl;
exports.InternalIntlWrapper = function (_a) {
    var _b = _a.locale, locale = _b === void 0 ? sdk_ui_1.DefaultLocale : _b, children = _a.children, workspace = _a.workspace;
    /**
     * Because of issues described in the ticket FET-855, we decided to use this workaround.
     * After the issues that are described in the ticket are solved or at least reduced,
     * this workaround can be removed.
     */
    var settings = window.gdSettings;
    if (settings) {
        var messages = react_1.useMemo(function () { return sdk_ui_1.pickCorrectWording(translations_1.translations[locale], settings); }, [locale, settings, translations_1.translations]);
        return (react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, messages: messages }, children));
    }
    else {
        return (react_1.default.createElement(sdk_ui_1.TranslationsCustomizationProvider, { translations: translations_1.translations[locale], workspace: workspace, render: function (modifiedTranslations) {
                return (react_1.default.createElement(react_intl_1.IntlProvider, { key: locale, locale: locale, messages: modifiedTranslations }, children));
            } }));
    }
};
//# sourceMappingURL=internalIntlProvider.js.map